import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedRoute } from '../../../features/tripcenter/routeSlice';
import { setNeedBounding } from '../../../features/map/mapSlice';

const GoogleMapRouteBounder = ({ map }) => {
    const selectedRoute = useSelector(selectSelectedRoute);
    const dispatch = useDispatch();

    useEffect(() => {
        const mapBounder = () => {
            if (map && window.google && selectedRoute?.routePath?.length > 0) {
                let bounds = new window.google.maps.LatLngBounds();

                // Sanitize and validate coordinates before extending bounds
                selectedRoute.routePath.forEach(point => {
                    const lat = parseFloat(point.lat);
                    const lng = parseFloat(point.lng);

                    if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
                        const latLng = new window.google.maps.LatLng(lat, lng);
                        bounds.extend(latLng);
                    }
                });

                // Fit the map to the bounds with padding
                map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
                dispatch(setNeedBounding(false));
            } else {
                dispatch(setNeedBounding(false));
            }
        };
        mapBounder();
    }, [map, selectedRoute, dispatch]);

    return null;
};

export default GoogleMapRouteBounder;
